<template>
  <el-table-column
    v-for="(item, key) in tableHeader"
    :key="key"
    :prop="item.prop"
    :label="item.label"
    :fixed="item.fixed"
    :min-width="item.minWidth"
    :width="item.maxWidth"
    :sortable="item.sortable ? item.sortable : false"
    :filters="item.filters"
    :column-key="item.columnKey"
    :filtered-value="item.filteredValue"
    :filter-multiple="item.filterMultiple"
    :align="item.align"
    :show-overflow-tooltip="item.tooltip"
    :render-header="item.renderHeader"
    :type="item.columnType"
  >
    <template #header="scope">
      <ex-slot v-if="item.customerHeader" :customer-header="item.customerHeader" :row="scope.row" :index="scope.$index" :column="item" />
      <span v-else>{{ item.label || '-' }}</span>
    </template>
    <template #default="scope">
      <template v-if="item.columns">
        <div style="display: none"></div>
        <ColumnItem :tableHeader="item.columns"> </ColumnItem>
      </template>
      <template v-else-if="item.slotName">
        {{ item.slotName }}
        <slot name="operation"></slot>
      </template>
      <span v-else>
        <ex-slot v-if="item.render || item.customer" :render="item.render" :customer="item.customer" :row="scope.row" :index="scope.$index" :column="item" />
        <el-input
          v-else-if="editingId === `${scope.$index}-${scope.cellIndex}`"
          size="small"
          class="light-input"
          v-model="nestedValueProxy"
          ref="inputRef"
          @blur="editingId = ''"
          @keyup.enter="editingId = ''"
        ></el-input>
        <span v-else @click="handleEdit(scope, item)">{{ getTargetValue(scope.row, item) || '-' }}</span>
      </span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: 'ColumnItem',
}
</script>

<script setup>
import { h, nextTick, ref, computed } from 'vue'
import lodash from 'lodash'
const props = defineProps({
  tableHeader: {
    type: Array,
    default: () => [],
  },
})

// 自定义内容的组件
const exSlot = {
  functional: true,
  props: {
    row: Object,
    render: Function,
    customer: Function, // 简化html render customer 均是渲染html模板
    customerHeader: Function,
    index: Number,
    column: {
      type: Object,
      default: null,
    },
  },
  render: props => {
    const params = {
      row: props.row,
      index: props.index,
    }

    if (props.column) params.column = props.column
    if (props.customerHeader) {
      // return h('div', [data.props.customerHeader(params)])
      return props.customerHeader(h, params)
    }
    if (props.customer) {
      return h('div', [props.customer(params)])
    }
    return props.render(h, params)
  },
}

const editingId = ref('')
const editingRow = ref(null)
const editingItem = ref(null)
const inputRef = ref(null)
const handleEdit = (scope, item) => {
  if (!item.editable) return
  editingId.value = `${scope.$index}-${scope.cellIndex}`
  editingRow.value = scope.row
  editingItem.value = item

  nextTick(() => {
    if (inputRef.value) {
      inputRef.value[0].focus()
    }
  })
}

// 使用计算属性创建一个代理，用于双向绑定嵌套值
const nestedValueProxy = computed({
  get() {
    return lodash.get(editingRow.value, editingItem.value.prop)
  },
  set(value) {
    if (editingId.value) {
      let set_value = value
      if (value === 'true') {
        set_value = true
      } else if (value === 'false') {
        set_value = false
      } else {
        set_value = isNaN(value * 1) ? value : value === '' ? '' : value * 1
      }
      console.log(set_value)
      lodash.set(editingRow.value, editingItem.value.prop, set_value)
    }
  },
})

// 获取目标值
const getTargetValue = (row, data) => {
  if (!data.prop) {
    return ''
  }
  const result = lodash.get(row, data.prop)
  if (result === 0) return '0'
  if (result === false) return 'false'
  return result
}
</script>

<style lang="scss"></style>
